import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

// 1. إضافة التوكن تلقائياً لكل request
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

let isLoggingOut = false;

// 2. معالجة الأخطاء (401 و 403)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // استخدام Optional Chaining بأناقة
    const status = error?.response?.status;
    const requestUrl = error?.config?.url;

    const isAuthRequest = requestUrl?.includes("/login");

    // معالجة 401 (انتهاء الجلسة أو غير مصرح)
    if (status === 401 && !isLoggingOut && !isAuthRequest) {
      isLoggingOut = true;

      localStorage.removeItem("token");
      localStorage.removeItem("user");

      window.location.href = "/login";
    }

    // معالجة 403 (ليس لديه صلاحية)
    // if (status === 403) {
    //   toast.error("عذرا ، لا تملك الصلاحيات الكافية للوصول إلى هذا المورد 🚫");
    // }

    return Promise.reject(error);
  }
);

export default axiosInstance;